import api from './api';

/**
 * Transportation Addl Charges support client. The master record CRUD goes through
 * the generic tablemaint engine (/tablemaint/additionalcharges); this covers the
 * master-detail extras: the Region option list and the effective-dated rates
 * sub-editor (additionalchargerates).
 */
export interface ChargeRate {
  recno: number; // 0 for an unsaved new row
  effectivedate: string;
  minimumrate: string;
  defaultrate: string;
}

export interface ChargeFormOptions {
  regions: string[];
}

const base = '/additional-charges';

const additionalChargesService = {
  async formOptions(signal?: AbortSignal): Promise<ChargeFormOptions> {
    const res = await api.get(`${base}/form-options`, { signal });
    return res.data as ChargeFormOptions;
  },

  async getRates(recno: number, signal?: AbortSignal): Promise<{ rates: ChargeRate[] }> {
    const res = await api.get(`${base}/${recno}/rates`, { signal });
    return res.data as { rates: ChargeRate[] };
  },

  async saveRates(
    recno: number,
    body: { deletes: number[]; rates: ChargeRate[] },
  ): Promise<{ recno: number }> {
    const res = await api.put(`${base}/${recno}/rates`, body);
    return res.data as { recno: number };
  },
};

export default additionalChargesService;
